import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {SavReferentiels} from '../../../../components/sav/Models'
import {getSavReferentiels, savErreur} from '../../../../components/sav/requests'

let cache: Promise<SavReferentiels> | null = null

// Référentiels actifs du module, chargés une fois par session de page
export const useSavReferentiels = (): SavReferentiels | null => {
  const [referentiels, setReferentiels] = useState<SavReferentiels | null>(null)

  useEffect(() => {
    cache ??= getSavReferentiels()
    cache.then(setReferentiels).catch((e) => {
      cache = null
      toast.error(savErreur(e))
    })
  }, [])

  return referentiels
}
